import React, {useState, useEffect} from 'react';
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import { MasterDataGrid } from "@/components/";
import BeneficiariesError from './beneficiaries-error';
import { Enums } from "@utils";

export interface IByLocationProps{    
    dataColumns: any;
	currentYear: string;
	status: any;
	screen: any;
    tableAlert: string;
    saveTable(instance: any): void;
}

const ByLocation: React.FC<IByLocationProps> = ({dataColumns, currentYear, status, screen, tableAlert, saveTable}: IByLocationProps) => {
    const [columns, setColumns] = useState(null);
    const [data, setData] = useState(null);
    const [auxData, setAuxData] = useState(null);

	const view: IFollowupSubproject = {
        state: {
			dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view); 

    useEffect(() => {
        if(dataColumns?._values?.length){
            let locationCol = presenter.getBeneficiariesColumns(status, currentYear, "byLocation");
            setColumns(locationCol)
        }
    }, [dataColumns, status?.CodigoDimension, status?.EnEdicion]);

    useEffect(() => {
        if(presenter.stepData && presenter.beneficiariesData) {
            let locationData = presenter.getBeneficiariesByLocationData(presenter.stepData, currentYear)
			setData(locationData)
        }
    }, [presenter.stepData, presenter.beneficiariesData]); 

    const checkDisaggregationEqual = () => {
        let disTable: any = presenter.getDataFromTable('beneficiaries-totals-other-table')
        let locTable: any = presenter.getDataFromTable('beneficiaries-bylocation')
		return presenter.checkDisaggregationEqual(disTable, locTable, status?.CodigoDimension)
    }

    useEffect(() => {
        if((tableAlert === `beneficiaries-bylocation` || !tableAlert || tableAlert === 'All') && data && columns) {
			if(presenter.stepTourBen > 1){
                let dataTour = presenter.getTourData(3, Enums.FollowupDimensions.beneficiaries)
                let asd = getAuxData(dataTour)
                setAuxData(asd)
            }else{
                let asd = getAuxData()
                setAuxData(asd)
            }
        }
    }, [data, tableAlert, columns, presenter.stepTourBen]); 

    const getAuxData = (tourData?: any) => {
		return (
            <>
                <BeneficiariesError 
                    followupLabels={presenter.followupLabels}
                    tableAlert={tableAlert}
                    calculatedReqFields={(item: any) => presenter.checkReqFields(item, status)} 
                    gridId={`beneficiaries-bylocation`} 
                    calculatedDisaggEqual={() => checkDisaggregationEqual()} 
                />
                <MasterDataGrid 
                    id={`beneficiaries-bylocation`}
                    dataSource={tourData || data.data}
                    columns={columns}
                    allowCode={screen}
                    gridTitle={presenter.followupLabels.get("beneficiariesByLocationTitle")}
                    gridHelpId={'tooltip-beneficiaries-bylocation'}
                    gridHelpText={presenter.followupLabels.get("helpBeneficiariesByLocation")}
                    saveTable={saveTable}
                    gridProps={{
                        width: 800,
                        editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
                        rowAlternationEnabled:false,
                        summary: {
                            recalculateWhileEditing: true,
                            totalItems: presenter.getBeneficiariesSummary()
                        }
                    }}
                />
            </>
        )
    }

    return (
            <>
            { (columns && auxData) ?
                <> 
                {auxData && auxData}
                </>
            :
                <></>
            }
        </>
    )
}

export default ByLocation;